import { Component, inject, Input } from '@angular/core'
import { RouteConfigLoadStart, Router } from '@angular/router'
import { SignalStore } from '@src/app/core/store/signalStore.js'
import { map } from 'rxjs/operators'

@Component({
  selector: 'app-spinner-component',
  template: `
    <div
      [class.show]="loading || store.$loading() || (isPageLoading | async)"
      class="spinner__svgContainer spinner__center"
    >
      <div class="spinner__svg spinner__center"></div>
    </div>
    <div
      [class.show]="loading || store.$loading() || (isPageLoading | async)"
      class="spinner__backdrop spinner__center"
    ></div>
  `,
  styleUrls: ['./spinner.component.scss'],
  standalone: false,
})
export class SpinnerComponent {
  store = inject(SignalStore)
  private router = inject(Router)

  @Input()
  public loading?: boolean

  readonly isPageLoading = this.router.events.pipe(
    map(event => {
      return event instanceof RouteConfigLoadStart
    }),
  )
}
